import { Col, Form, Row } from 'antd';
// import { MaskedInput } from 'antd-mask-input';
import { observer } from 'mobx-react-lite';

import { InputDigits } from 'app/ui/input-digits';

type Fields = 'phone';
// for tab validation icon
export const CredentialsFieldsPath: Record<Fields, string[]> = {
  phone: ['phone'],
};

export const CredentialFields = observer(() => {
  return (
    <>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Номер телефона"
            name={CredentialsFieldsPath.phone}
            rules={[
              { required: true, message: 'Поле обязательно для заполнения' },
              {
                pattern: /^\d+$/,
                message: 'Поле должно содержать только цифры',
              },
            ]}
          >
            <InputDigits placeholder="37400000000" />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
});
